module.exports = __webpack_public_path__ + "static/img/91BM-054-JiajunLiu.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-054-JiajunLiu.jpg
// module id = /+R9
// module chunks = 0